import type { ThunkDispatch } from '@reduxjs/toolkit'
// eslint-disable-next-line no-restricted-imports -- this is the one place the raw hooks are wrapped
import { useDispatch, useSelector } from 'react-redux'
import type { UnknownAction } from 'redux'
import type { RootState } from './store'

export type { RootState }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AppDispatch = ThunkDispatch<RootState, any, UnknownAction>

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()

/**
 * Typed selector hook. The first overload enforces RootState for statically
 * registered slices. The second overload handles selectors for code-split
 * (dynamically-injected) slices whose types are not in the static RootState.
 */
export function useAppSelector<TSelected>(
  selector: (state: RootState) => TSelected
): TSelected
export function useAppSelector<TState, TSelected>(
  selector: (state: TState) => TSelected
): TSelected
export function useAppSelector<TState, TSelected>(
  selector: (state: TState) => TSelected
): TSelected {
  return useSelector(selector as unknown as (state: RootState) => TSelected)
}
